var common = require("../../../utiles/common.js")
var service = require("../../../utiles/service")

module.exports = {
    register: function () {
        document.createElement('record')
        ko.components.register('record', {
            viewModel: function (params) {
                var arrId = location.hash.replace("#/recordIndex/", "").split('/');
                console.log(arrId)
                var $this = this;
                var pageIndex = 1;
                $this.isNumber = ko.observable(true);
                $this.userId = sessionStorage.getItem('currentId');//service.user.getUser().id;
                $this.name = arrId[2];
                $this.records = ko.observable('');
                $this.closePage = function(){
                    common.redirectTo("/#/appConfig/" + arrId[1]);
                }

                $this.getList = function(index){
                    console.log("isNumber----------"+$this.isNumber());
                    if(!$this.isNumber()&&!index)return false;
                    if(!index){
                        pageIndex++;
                    }else{
                        pageIndex=1;
                    }
                    var param={
                        accountName:arrId[2],
                        appId:arrId[1],
                        entitlementId:arrId[0],
                        pageSize:10,
                        pageNumber:index?index:pageIndex,
                    }
                    // $this.datas = service.logs.loginLog(param)?service.logs.loginLog(param).data:[];
                    var log = service.logs.loginLog(param).data;
                    $this.num = log?log.totalNumber:0;
                    $this.isNumber(true);
                    $(".zxf_pagediv").createPage({
                        total:log.totalNumber,
                        pageNum: log.totalPage,
                        current: log.pageNumber,
                        backfun: function(e) {
                            param.pageNumber = e.current;
                            log = service.logs.loginLog(param).data;
                            $this.records(log.logs);
                        }
                    });
                    if(log.logs&&log.logs.length<10){
                        $this.isNumber(false)
                    }
                    $this.records(log.logs);
                    // if($this.datas&&$this.datas.logs&&$this.datas.logs.length<10){
                    //     $this.isNumber(false)
                    // }
                    // if(index){
                    //     $this.records($this.datas.logs);
                    //     setTimeout(function(){
                    //        $this.scrollBottomTest();
                    //     },1000)
                    // }else{
                    //     $this.records($this.records().concat($this.datas.logs));
                    // }
                }
                $this.scrollBottomTest = function(){
                    $("#trackItem").scroll(function(){
                        var self=$(this),
                        viewH =self.height(),
                        contentH =self.get(0).scrollHeight,
                        scrollTop =self.scrollTop();
                        if(contentH - viewH - scrollTop < 100) {
                            if($this.isNumber()){
                                $this.getList();
                            }
                        }
                    });
                }
                $this.getList(1);
            },
            template: require("./Record.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/appConfig/template/Record.js
// module id = 141
// module chunks = 0